import { cn } from '@dialogueconsulting/sked-ui/lib/utils'
import * as React from 'react'

/**
 * Loading skeleton with the design-system shimmer animation
 * (--animate-shimmer token ported from the dashboard tailwind config).
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'animate-shimmer rounded-md bg-[linear-gradient(110deg,var(--color-neutral-50)_8%,var(--color-neutral-100)_18%,var(--color-neutral-50)_33%)] bg-[length:200%_100%]',
        className
      )}
      {...props}
    />
  )
}

export { Skeleton }
